export default {
  "steps-vertical": {
    tender: {
      title: "Nous encadrons votre appel d'offres",
      description:
        "Nous avons définit le cahier de charges de votre système solaire optimal indépendamment des maîtres d'oeouvres.",
    },
    publish: {
      title: "Vous publiez votre demande de devis",
      description:
        "Vous confirmez les informations techniques à votre cahier de charges pour obtenir des propositions pertinentes.",
    },
    published: {
      title: "Maîtres d'ouvres recoivent votre demande de devis",
      description:
        "Votre demande inclut le dossier technique avec votre cahier de charges, et exclut vos coordonnées : zéro démarchage possible.",
    },
    quotes: {
      title: "Vous recevez des devis sur-mesure",
      description:
        "Les maîtres d'ouvres choisissent leur matériel en respectant votre cahier de charges et les contraintes techniques.",
    },
  },

  "steps-horizontal": {
    "launch-tender": {
      title: "Lancez votre appel d’offres privé",
      description:
        "Pour le démarrage de votre projet solaire, après avoir étudié ensemble vos options et votre cahier de charges, lancez un appel d’offres privé auprès de nos installateurs agréés. Nous vous accompagnons tout au long du processus pour répondre à vos questions. ",
    },
    quotes: {
      title: "Recevez des devis d’installateurs agréés",
      description:
        "Une fois l’appel d’offres lancé, recevez des propositions et devis de la part de nos installateurs en fonction des paramètres établis et de leur localisation. Nous vous encourageons à privilégier l’artisanat de proximité. ",
    },
    select: {
      title: "Choisissez votre proposition et planifiez la visite technique",
      description:
        "Après avoir parcouru les différentes propositions, choisissez celle qui vous correspond. Vous pouvez demander un accompagnement si vous le souhaitez. Planifiez alors la visite technique pour valider la faisabilité du chantier.",
    },
    "sign-contract": {
      title: "Signez le devis et c’est parti !",
      description:
        "Après la validation de faisabilité du chantier, signez le devis final. Votre installation peut alors commencer ! Suivez son avancée depuis votre tableau de bord. ",
    },
  },
  auction: "Appel d'offres",
  hire: "Engager directement",
  "service-types": {
    installation_only: "Installation uniquement",
    installation_and_hardware_supply: "Installation et fourniture du matériel",
    maintenance: "Maintenance",
    construction: "Travaux de construction"
  }
}
